import { ReactElement } from 'react';

import { Dropdown, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { prescriptionVisitsTranslationKeys } from '../../../../translations';

type PatientHistoryDropdownItemProps = {
   readonly patientId: number;
};

export const PatientHistoryDropdownItem = (props: PatientHistoryDropdownItemProps): ReactElement => {
   const push = useHistoryPushWithBackAction(true);

   const handleClick = (hide: VoidFunction): void => {
      push(
         visitPaths.getVisitHistoryPath({
            params: {
               patientId: props.patientId,
            },
            searchParams: {},
         }),
         {
            label: prescriptionVisitsTranslationKeys.goBackToPrescriptionVisits,
         }
      );
      hide();
   };

   return (
      <Dropdown.Item testId={'patientHistory'} onClick={handleClick}>
         {prescriptionVisitsTranslationKeys.patientHistory}
      </Dropdown.Item>
   );
};
